import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Marketing from './Marketing'

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Marketing />} />
      </Routes>
    </Router>
  )
}

export default App
